import React from 'react'

import {noop} from 'es-toolkit'

import './select-menu-item.scss'

import cn from '../../libs/class-names'

import checkedItem from '../../assets/icons/checked.svg'

import Icon from '../icon'
import LabeledCheckbox from '../labeled-checkbox-field'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  selected?: boolean
  multiple?: boolean
  variant?: 'base' | 'headline'
  onClick?: React.MouseEventHandler
}

const SelectMenuItem = React.forwardRef(
  (
    {
      classNames,
      children,
      selected = false,
      multiple = false,
      variant = 'base',
      onClick = noop,
    }: Props,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => {
    const handleClick = (event: React.MouseEvent) => {
      event.preventDefault()
      onClick(event)
    }

    if (variant === 'headline') {
      return (
        <div className={cn('SelectMenuItem', {[`variant-${variant}`]: !!variant}, classNames)}>
          <span className="SelectMenuItem__label">{children}</span>
        </div>
      )
    }

    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          'SelectMenuItem',
          {selected, multiple, [`variant-${variant}`]: !!variant},
          classNames
        )}
        onClick={handleClick}
      >
        {multiple && <LabeledCheckbox size="90" checked={selected} label={children} />}
        {!multiple && (
          <>
            <span className="SelectMenuItem__label">{children}</span>
            {selected && (
              <span className="SelectMenuItem__selected">
                <Icon source={checkedItem} />
              </span>
            )}
          </>
        )}
      </button>
    )
  }
)

SelectMenuItem.displayName = 'SelectMenuItem'

export default SelectMenuItem
